import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reportBuilderApi } from '../api/reportBuilderApi';

/**
 * DELETE /api/eraf/report-builder/reports/{id} — 리포트 정의 삭제 (REPORT_CREATE + owner)
 */
export function useDeleteReportDef() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => reportBuilderApi.remove(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['report-builder', 'list'] });
    },
  });
}
